
import React from 'react';
import { useParams } from 'react-router-dom';
import InternalLineItemForm from '@/components/internal/InternalLineItemForm';

const EditInternalLineItemPage = () => {
  const { id } = useParams<{ id: string }>();
  
  console.log("Edit line item page loaded with ID:", id);

  return (
    <div>
      <InternalLineItemForm lineItemId={id} />
    </div>
  );
};

export default EditInternalLineItemPage;
